<template>
  <div class="task" v-if="taskClone" style="height: 80px">
    <inline-editable-text
      @change="onCreateTask($event)"
      @lost-focus="onLostFocus"
      @cancel="onLostFocus"
      :value="taskClone.name"
      ref="task_name"
      :inline="false"
      :tooltip="null"
      :resetOnUpdate="true"
      :hideButtons="false">
    </inline-editable-text>
  </div>
</template>

<script>
import util from '@/util'
import TaskManagementMixin from "@/components/Mixins/TaskManagement"

export default {
  mixins: [ TaskManagementMixin ],
  props: {
    goalId: {},
    memberId: {},
    laneId: {},
    sessionId: {
      type: String
    },
    tasksInSession: {
      type: Array
    },
  },
  data() {
    return {
      taskClone: null,
    }
  },
  created() {
    this.createEmptyTask()
  },
  mounted() {
    this.focus();
  },
  methods: {
    createEmptyTask() {
      // console.log("CREATE EMPTY TASK")
      let userId = this.$models.user.defaultUserId
      this.taskClone = this.$models.taskMeta
        .with({ goalId: this.goalId, uid: this.memberId })
        .new_from_template({ userId })

      // this.taskClone.setValidationBehaviour('ELEMENT_VALIDATION')
      this.taskClone.name = '';
      this.taskClone.laneId = this.laneId;
    },

    focus() {
      this.createEmptyTask()
      this.$nextTick(() => {
        if (this.$refs.task_name) {
          this.$refs.task_name.focus();
        }
      })
    },

    onLostFocus() {
      // console.log("LOST FOCUS")
      this.$emit('cancel')
    },

    onCreateTask(text) {
      // console.log("CREATE TASK")
      let result = util.matchUserInputDuration( text )

      if ( result.match ) {
        this.taskClone.durationRemaining = result.duration
      }

      this.taskClone.name    = result.text
      this.taskClone.sortidx = this.$api.get_last_sortidx_for_tasks(this.goalId, this.memberId, this.laneId);
      this.taskClone.userId  = this.memberId;
      this.taskClone.sessionId = this.sessionId

      this.taskClone.write().then(taskId => {
        let task = {
          goalId: this.goalId,
          memberId: this.memberId,
          taskId: taskId,
          tasksInSession: this.tasksInSession,
          sessionId: this.sessionId
        }
        this.onAddTaskToSession(task)
        this.createEmptyTask();
        this.$emit('task-created')
      });
      this.$emit('task-creating')
      }
  },
};
</script>
